<template>
  <v-navigation-drawer
    :value="isOpenTemplateTranslations"
    :permanent="isOpenTemplateTranslations"
    width="500px"
    max-width="100vw"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="z-index: 12;transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        ref="base-toolbar"
        :dark="false"
        @close="close"
        :title="$tc('common.translation', 2)"
        type-title="icon"
        icon="translate"
        color="white"
      />
      <v-card-text style="overflow-y: auto;height: calc(100vh - 64px)">
        <v-container>
          <v-row dense class="mb-5">
            <v-col cols="12">
              <v-card>
                <v-card-title class="title grey--text text--darken-3">
                  {{ $tc('common.language', 2) }}
                  <v-spacer />
                  <v-btn
                    @click="openCreateDialog()"
                    color="primary"
                  >
                    {{ $t('actions.add') }}
                  </v-btn>
                </v-card-title>
                <v-divider />
                <v-card-text>
                  <v-row dense>
                    <template v-if="translations.length">
                      <v-col v-for="translation in translations" :key="translation.language_code" cols="12">
                        <v-card
                          @click.stop="openTemplateDesign(translation)"
                          outlined
                          hover
                          color="grey lighten-3"
                        >
                          <v-card-title class="subtitle-1 font-weight-medium">
                            <v-icon v-text="'translate'" left />
                            <span v-text="translation.name" class="mr-1" />
                            (<span v-text="translation.language_code" class="text-uppercase" />)
                            <v-spacer />
                            <v-btn
                              @click.stop="translation.is_default
                                ? false
                                : setDefaultTranslation({
                                  template_id: translation.template_id,
                                  translation_id: translation.id,
                                })"
                              :color="translation.is_default ? 'amber darken-2' : ''"
                              icon
                            >
                              <v-icon
                                v-text="translation.is_default
                                  ? 'star'
                                  : 'star_border'"
                              />
                            </v-btn>
                            <v-menu bottom left min-width="150px">
                              <template v-slot:activator="{ on }">
                                <v-btn ref="item-menu-button-open" v-on="on" @click.stop icon>
                                  <v-icon>more_vert</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <!-- <v-list-item ref="item-button-open-detail" @click="showEmail(item.id)">
                                  <v-list-item-title>
                                    {{ $t('actions.detail') }}
                                  </v-list-item-title>
                                </v-list-item> -->
                                <v-list-item
                                  ref="item-button-open-editor"
                                  @click="openTemplateDesign(translation)"
                                >
                                  <v-list-item-title>
                                    {{ $t('actions.edit') }}
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                  ref="item-button-open-remove"
                                  v-if="!translation.is_default"
                                  @click="openRemoveDialog(translation.id)"
                                >
                                  <v-list-item-title>
                                    {{ $t('actions.delete') }}
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-card-title>
                        </v-card>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="12">
                        <v-img
                          :src="require('@/assets/svg/box_empty.svg')"
                          height="150"
                          max-height="150px"
                          aspect-ratio="1"
                          contain
                        />
                        <div class="text-center">
                          {{ $t('common.no_results_found') }}
                        </div>
                      </v-col>
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="createDialog.display" persistent max-width="400px">
      <v-card>
        <v-card-title class="pa-4 headline">
          {{
            $t('templates.translations.create.title')
          }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-autocomplete
            v-model="createDialog.language_code"
            v-validate="'required'"
            :items="avaliableLanguages"
            :label="$tc('common.language', 1)"
            :error-messages="errors.collect($tc('common.language', 1))"
            :data-vv-name="$tc('common.language', 1)"
            required
            item-text="name"
            item-value="code"
            outlined
            dense
            class="mt-6"
          />
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            @click="closeCreateDialog()"
            :loading="createDialog.loading"
            color="primary"
            outlined
          >
            {{ $t('actions.cancel') }}
          </v-btn>
          <v-btn
            @click="submitCreateTranslation()"
            :loading="createDialog.loading"
            color="primary"
            depressed
          >
            {{ $t('actions.accept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <BaseConfirmDialog
      v-if="removeDialog.display"
      :title="'Remove tranlation'"
      :description="'Are you sure?'"
      :accept-text="$t('actions.accept')"
      :cancel-text="$t('actions.cancel')"
      :submit-loading="removeDialog.loading"
      @close="closeRemoveDialog()"
      @proceed="submitRemoveTranslation()"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar'
import BaseConfirmDialog from '@/components/BaseConfirmDialog'
import languages from '@/data/languages.json'

export default {
  components: {
    BaseToolbar,
    BaseConfirmDialog
  },
  data () {
    return {
      loading: false,
      createDialog: {
        display: false,
        loading: false,
        language_code: null
      },
      removeDialog: {
        display: false,
        loading: false,
        translation_id: null
      }
    }
  },
  watch: {
    isOpenTemplateTranslations (newVal) {
      if (newVal) {}
    }
  },
  computed: {
    ...mapGetters({
      template: 'templates/template',
      windowSize: 'windowSize',
      isOpenTemplateTranslations: 'templates/isOpenTemplateTranslations'
    }),
    translations () {
      if (this.template && this.template.translations) {
        return this.template.translations.map(translation => {
          const { name } = languages.find(({ code }) => translation.language_code === code)
          translation.name = name
          return translation
        })
      }
      return []
    },
    avaliableLanguages () {
      if (this.template && this.template.translations) {
        return languages.filter(e => !this.template.translations.some(({ language_code }) => language_code === e.code))
      }
      return languages
    }
  },
  async created () {
    this.loading = true
    this.loading = false
  },
  methods: {
    ...mapActions({
      saveTranslation: 'templates/saveTranslation',
      removeTranslation: 'templates/removeTranslation',
      setDefaultTranslation: 'templates/setDefaultTranslation'
    }),
    ...mapMutations({
      setTranslation: 'templates/setTranslation',
      toggleTemplateTranslations: 'templates/toggleTemplateTranslations',
      openTemplateDesignEditor: 'templates/openTemplateDesignEditor'
    }),
    handlerInput (arg) {
      if (!arg) { this.close() }
    },
    cleanData () {
      this.loading = false
    },
    close () {
      this.toggleTemplateTranslations(false)
      this.cleanData()
    },
    async submitCreateTranslation () {
      const { language_code } = this.createDialog
      const isValid = await this.$validator.validateAll()
      if (!isValid) { return }
      this.createDialog.loading = true
      const { success } = await this.saveTranslation({
        template_id: this.template.id,
        language_code
      })
      if (success) {
        this.closeCreateDialog()
        this.openTemplateDesignEditor()
      } else {
        this.createDialog.loading = false
      }
    },
    openCreateDialog () {
      this.createDialog.display = true
    },
    closeCreateDialog () {
      this.createDialog.display = false
      this.createDialog.loading = false
      this.createDialog.language_code = null
      this.$validator.reset()
    },
    async submitRemoveTranslation () {
      const { translation_id } = this.removeDialog
      this.removeDialog.loading = true
      const { success } = await this.removeTranslation({
        template_id: this.template.id,
        translation_id
      })
      if (success) {
        this.closeRemoveDialog()
      } else {
        this.removeDialog.loading = false
      }
    },
    openRemoveDialog (translation_id) {
      this.removeDialog.translation_id = translation_id
      this.removeDialog.display = true
    },
    closeRemoveDialog () {
      this.removeDialog.display = false
      this.removeDialog.loading = false
      this.removeDialog.translation_id = null
    },
    openTemplateDesign (translation) {
      this.setTranslation(translation)
      this.openTemplateDesignEditor()
    }
  }
}
</script>
